import { takeLatest, all, call, put } from "redux-saga/effects";
import { 
    startGettingProfile,
    setProfile,
    completedFetch,
    startEditProfileData,
    completedEditProfileData,
 } from "./profile.slice.selector";

import { setNotificationAction } from "../NotificationStore/notification.slice.selector";
import { 
    editProfileData,
    getProfileData 
} from "../../../Apis/Profile/profile";

//(1) Watcher
function* startFetchProfileData() {
  yield takeLatest(startGettingProfile.type, setProfileData);
}
//(1) Next
function* setProfileData({ payload }) {
  try {
    const response_data = yield call(getProfileData, payload);

    yield put(setProfile(response_data));

    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(2)Wacther
function* startEditProfile() {
  yield takeLatest(startEditProfileData.type, callForEditProfile);
}
//(2)Next
function* callForEditProfile({ payload }) {
  try {
    yield call(editProfileData, payload);
    yield put(completedEditProfileData());
    yield put(
      setNotificationAction({
        message: "User Added Successfully",
        variant: "success",
      })
    );
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedEditProfileData());
  }
}


///Accumulator
export default function* profileSaga() {
  yield all([
    call(startFetchProfileData),
    call(startEditProfile),
  ]);
}
